import { render, staticRenderFns } from "./SidebarArrow.vue?vue&type=template&id=060ad7dc"
import script from "./SidebarArrow.vue?vue&type=script&lang=js"
export * from "./SidebarArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports